import { Pipe, PipeTransform } from '@angular/core';

/**
 * Renders a missing / unknown value as "—" (em dash) per the CapX style guide
 * (Microcopy & Accessibility): "Always — (em dash). Never 'N/A', 'None', blank,
 * or null."
 *
 * Catches null, undefined, empty string, and whitespace-only — which a plain
 * `?? '—'` misses (the API returns dormant fields as "", not null). Any other
 * value (including 0 and false) is passed through unchanged.
 *
 *   {{ facility.dri_band | dash }}     → "—"   (when "" or null)
 *   {{ facility.dri_band | dash }}     → "B"   (when populated)
 */
@Pipe({ name: 'dash', standalone: true, pure: true })
export class DashPipe implements PipeTransform {
  transform(value: unknown): unknown {
    if (value === null || value === undefined) {
      return '—';
    }
    if (typeof value === 'string' && value.trim() === '') {
      return '—';
    }
    return value;
  }
}
